import React from "react";
import "./Values.css";

export default function Values() {
  return (
    <section className="values">
      <h2>Nos Valeurs</h2>
      <p>
        Transparence, collaboration et innovation sont nos piliers. En appliquant
        ces principes du début à la fin, nous garantissons des résultats
        exceptionnels et une solution unique, à l’image de votre idée.
      </p>

      <div className="values-list">
        <div className="value-item">
          <h3>Une expertise fiable</h3>
          <p>
            Avec nos années d’expérience, nous avons géré de nombreux projets,
            en apportant des solutions sur mesure à chaque client.
          </p>
        </div>
        <div className="value-item">
          <h3>Un service qui parle</h3>
          <p>
            Nous croyons en la proximité et l’agilité. Nous restons toujours à
            l’écoute de nos clients afin de leur offrir le meilleur.
          </p>
        </div>
        <div className="value-item">
          <h3>Approche centrée sur le client</h3>
          <p>
            Chaque projet est unique et mérite une attention particulière.
            Notre engagement repose sur la satisfaction durable de nos clients.
          </p>
        </div>
      </div>
    </section>
  );
}
